(() => {
  let toastTimer;
  const toast = document.querySelector("[data-toast]");
  const nav = document.querySelector("[data-nav]");
  const menuToggle = document.querySelector("[data-menu-toggle]");
  const searchDialog = document.querySelector("[data-search-dialog]");
  const searchInput = document.querySelector("[data-search-input]");

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove("is-visible"), 2600);
  }

  document.addEventListener("click", (event) => {
    const filterButton = event.target.closest("[data-filter]");
    if (filterButton) {
      const activeFilter = filterButton.dataset.filter;
      document.querySelectorAll("[data-filter]").forEach((button) => {
        button.classList.toggle("is-active", button === filterButton);
      });
      document.querySelectorAll("[data-product-card]").forEach((card) => {
        const shouldShow =
          activeFilter === "all" ||
          card.dataset.audience === activeFilter ||
          card.dataset.type === activeFilter;
        card.hidden = !shouldShow;
      });
    }

    if (event.target.closest("[data-open-search]")) {
      if (searchDialog && typeof searchDialog.showModal === "function") {
        searchDialog.showModal();
        searchInput?.focus();
      }
    }
  });

  menuToggle?.addEventListener("click", () => {
    const isOpen = nav?.classList.toggle("is-open");
    document.body.classList.toggle("menu-open", Boolean(isOpen));
    menuToggle.setAttribute("aria-expanded", String(Boolean(isOpen)));
  });

  nav?.addEventListener("click", () => {
    nav.classList.remove("is-open");
    document.body.classList.remove("menu-open");
    menuToggle?.setAttribute("aria-expanded", "false");
  });

  document.querySelectorAll(".quick-add-form").forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const button = form.querySelector("button");
      const formData = new FormData(form);

      try {
        button?.setAttribute("disabled", "disabled");
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData,
        });
        if (!response.ok) throw new Error("Unable to add item");
        const item = await response.json();
        const cart = await fetch("/cart.js", { headers: { Accept: "application/json" } }).then((res) => res.json());
        document.querySelectorAll("[data-cart-count]").forEach((el) => {
          el.textContent = String(cart.item_count);
        });
        showToast(`${item.product_title || "Item"} added to cart`);
      } catch (error) {
        form.submit();
      } finally {
        button?.removeAttribute("disabled");
      }
    });
  });
})();
